import React, { useState, useEffect } from 'react';
import apiSpecifications from '../../../api/specifications';
import MultiSelect from '../../layout/forms/MultiSelect';

const Specifications = ({ selected, setSelected }) => {
    const [specifications, setSpecifications] = useState([]);
  
    const fetchSpecifications = async (objectTypes) => {
        const result = await apiSpecifications.post(objectTypes.map(objectType => objectType.value));
        setSpecifications(result.map(specification => ({ label: specification.specificationCode, value: specification.spesificationKEY })));
    }

    useEffect(() => {
        fetchSpecifications(selected.objectTypes);
    }, [selected.objectTypes]);
    const setSelectedSpecifications = (specifications) => {
        console.log (specifications)
        setSelected({ ...selected, specifications });
    }
    return (
        <MultiSelect
            options={specifications}
            value={selected.specifications}
            onChange={setSelectedSpecifications}
            labelledBy="Specifications"
            label="Specification"
        />
    )
}
export default Specifications